"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BrandsMessageSetTemplatesListCtl = /** @class */ (function (_super) {
    __extends(BrandsMessageSetTemplatesListCtl, _super);
    function BrandsMessageSetTemplatesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_message_action_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.message_action_code; });
        _this.dk_message_action_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.message_action_title; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_app_language_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_id; });
        _this.dk_app_language_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_title; });
        _this.dk_for_test_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.for_test_login; });
        _this._errDialog = errDialog;
        return _this;
    }
    BrandsMessageSetTemplatesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    BrandsMessageSetTemplatesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    BrandsMessageSetTemplatesListCtl.prototype.LoadData = function (Key, onDone) {
        var _this = this;
        webAApi_1.ListBrandMessageSetTemplatesByBrandIdGet.exec({ brand_id: Key }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    description: resp.list[i].description,
                    message_action_code: resp.list[i].message_action_code,
                    message_action_title: resp.list[i].message_action_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    app_language_id: resp.list[i].app_language_id,
                    app_language_title: resp.list[i].app_language_title,
                    for_test_login: resp.list[i].for_test_login
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsMessageSetTemplatesListCtl.prototype.AddGwsMessageTemplate = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandMessageSetTemplate.exec({
            data: {
                brand_id: data.brand_id,
                title: data.title,
                message_action_code: data.message_action_code,
                description: data.description,
                app_language_id: data.app_language_id
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_added: moment(resp.date_added_uts_ms).utc(false),
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                description: data.description,
                title: data.title,
                message_action_code: data.message_action_code,
                message_action_title: resp.message_action_title,
                app_language_id: data.app_language_id,
                app_language_title: resp.app_language_title,
                for_test_login: ""
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsMessageSetTemplatesListCtl.prototype.EditGwsMessageTemplate = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBrandMessageSetTemplate.exec({
                data: {
                    message_set_template_id: data.key,
                    title: data.title,
                    message_action_code: data.message_action_code,
                    description: data.description,
                    app_language_id: data.app_language_id,
                }
            }, function (resp) {
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.title = data.title;
                _tmp.message_action_code = data.message_action_code;
                _tmp.description = data.description;
                _tmp.message_action_title = resp.message_action_title;
                _tmp.app_language_id = data.app_language_id;
                _tmp.app_language_title = resp.app_language_title;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsMessageSetTemplatesListCtl.prototype.DeleteGwsMessageTemplate = function (MessageSetTemplateId, onDone) {
        var _this = this;
        var _tmp = this.getById(MessageSetTemplateId);
        if (_tmp) {
            webAApi_1.DoDeleteBrandMessageSetTemplate.exec({ data: { message_set_template_id: MessageSetTemplateId } }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsMessageSetTemplatesListCtl.prototype.CheckGwsMessageTemplate = function (MessageSetTemplateId, onDone) {
        var _this = this;
        webAApi_1.DoCheckBrandMessageSetTemplate.exec({
            data: {
                message_set_template_id: MessageSetTemplateId,
            }
        }, function (resp) {
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsMessageSetTemplatesListCtl.prototype.GetRawTestJSONData = function (MessageGwsSetId, onDone) {
        var _this = this;
        webAApi_1.DoGetRawBrandMessageSetMockObjectForTest.exec({
            data: {
                message_set_template_id: MessageGwsSetId
            }
        }, function (resp) {
            if (onDone) {
                onDone(resp.mockup_json_base64);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsMessageSetTemplatesListCtl.prototype.SetGwsMessageTemplateContent = function (key, tplBase64, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoEditBrandMessageSetTemplateData.exec({ data: {
                    message_set_template_id: key,
                    template_base64: tplBase64
                } }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsMessageSetTemplatesListCtl.prototype.SetGwsMessageTestJSONContent = function (key, testBase64, forTestLogin, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoEditBrandMessageSetTestJSONData.exec({ data: {
                    message_set_template_id: key,
                    for_test_json_b64: testBase64,
                    for_test_login: forTestLogin
                } }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsMessageSetTemplatesListCtl.prototype.GetGwsMessageTemplateContent = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DetailsBrandMessageSetTemplateDataGet.exec({ message_set_template_id: key }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone(resp.template_base64, resp.for_test_json_b64);
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BrandsMessageSetTemplatesListCtl;
}(BaseController_1.BaseController));
exports.BrandsMessageSetTemplatesListCtl = BrandsMessageSetTemplatesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ctl/options/BrandsMessageSetTemplateListCtl.ts
// module id = 1052
// module chunks = 0